import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthModule } from '@elight/client/shared/utility/auth';

@NgModule({
    imports: [CommonModule, AuthModule],
    exports: [],
})
export class CoreModule {}
